import { DollarSign, Home, Package, Settings, Wrench } from 'lucide-react';
import { useUserProfile } from '../../context/UserProfileContext';
import { useOrgSettings } from '../../hooks/useOrgSettings';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';
import { IS_FIREBASE_CONFIGURED } from '../../config/firebase';

const isDevMode = !IS_FIREBASE_CONFIGURED;

export function QuotingHubPage() {
  const { adminOrg } = useUserProfile();
  const { org } = useOrgSettings(adminOrg?.orgId ?? '');
  const orgData = org as unknown as Record<string, unknown> | null;

  const commercialEnabled = isDevMode || (orgData?.featureCommercialMovingQuotes !== false);
  const residentialEnabled = isDevMode || ((orgData?.featureResidentialMovingQuotes ?? false) as boolean);

  // Quote Defaults is always visible, but some cards within it are gated
  // Rate Cards is always visible, but residential flat rates are gated
  // Residential Rooms is fully gated
  // Inventory Items & Services are always visible (tabs within are gated)

  const rows: SettingsRowDef[] = [
    {
      id: 'quote-defaults',
      label: 'Quote Defaults',
      desc: 'Currency, units, efficiency, expiration, and itemization.',
      icon: Settings,
      path: '/admin/quoting/quote-defaults',
    },
    {
      id: 'rate-cards',
      label: 'Rate Cards',
      desc: 'Crew and truck hourly rates, residential flat rates.',
      icon: DollarSign,
      path: '/admin/quoting/rate-cards',
    },
    {
      id: 'residential-rooms',
      label: 'Residential Rooms',
      desc: 'Room inventories, auto-add rules, and smart profiles.',
      icon: Home,
      path: '/admin/quoting/residential-rooms',
      isVisible: residentialEnabled,
    },
    {
      id: 'inventory-items',
      label: 'Inventory Items',
      desc: 'Manage furniture and equipment catalogs.',
      icon: Package,
      path: '/admin/quoting/inventory-items',
      isVisible: commercialEnabled || residentialEnabled,
    },
    {
      id: 'services',
      label: 'Services',
      desc: 'Manage services offered during a move.',
      icon: Wrench,
      path: '/admin/quoting/services',
      isVisible: commercialEnabled || residentialEnabled,
    },
  ];

  return (
    <HubPageLayout
      title="Quoting"
      subtitle="Rates, inventory, services, and quote settings."
      rows={rows}
    />
  );
}
